import React from "react";
import { createRoot } from "react-dom/client";
import { GlobalRoot } from "./GlobalRoot.js";
import { initHamburgerToggle, initUserDropdownToggle } from "./hamburger.js";

function bootstrap() {
  let host = document.getElementById("global-react-root") as HTMLElement | null;
  if (!host) {
    host = document.createElement("div");
    host.id = "global-react-root";
    document.body.appendChild(host);
  }
  const containerEl = document.querySelector(".app-container") as HTMLElement | null;
  const userName = host.getAttribute("data-user-name") || (document.querySelector(".user-name")?.textContent || "");
  const photoUrl = host.getAttribute("data-user-photo") || "";
  const root = createRoot(host);
  root.render(<GlobalRoot userName={userName} photoUrl={photoUrl} containerEl={containerEl} />);

  const disposeHamburger = initHamburgerToggle();
  const disposeUserMenu = initUserDropdownToggle();

  window.addEventListener("beforeunload", () => {
    try { root.unmount(); } catch {}
    disposeHamburger();
    disposeUserMenu();
  }, { once: true });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", bootstrap, { once: true });
} else {
  bootstrap();
}